import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { CSVLink } from 'react-csv';
import { colors } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {}
}));

const Header = props => {
  const { className, downloadPriceSummary,data,isdownloadready, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="flex-end"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid item>
          {/* <Typography
            component="h2"
            gutterBottom
            variant="overline"
          >
            Management
          </Typography> */}
          <Typography
            component="h1"
            variant="h3"
          >
           Live Price Summary
          </Typography>
        </Grid>
        <Grid item>
         {(localStorage.getItem('role') === 'Super Admin' || localStorage.getItem('access').includes('download_price_summary')) && 
         
         <>
         {isdownloadready ?
            <Button
          className={classes.filterButton}
          color="primary"
          size="small"
          variant="outlined"
        >
        
         <CSVLink
                    headers={ [
                    {"label" : "Commodity Name","key":"commodity"},
                    {"label" : "Sub Commodity Name","key":"subcommodity"},
                    {"label" : "Product Name","key":"product"},
                    {"label" : "Price","key":"price"},
                    {"label" : "Date","key":"price_date"}
                                       ]}
                    data={data}
                    filename={data?.length > 0 ? data[0]?.product : "price-summary"}
                    style={{ "textDecoration": "none", "color": colors.teal[700] }}
                >
           {`Download ${data?.length}`}
                </CSVLink> 
        </Button>
         : <Button
            color="primary"
            variant="contained"
            onClick={() => {
              downloadPriceSummary();
            }}
          >
           Download Price Summary 
          </Button> }
          </>
         } 
        </Grid>
      </Grid>
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
